module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "yxl-logo"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-e5226a14!./~/._vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/yxl-logo.vue
// module id = 139
// module chunks = 2